import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { IntroducerFundingGapView } from '../components/views/introducerFundingGapView/index'

function IntroducerFundingGap() {
    return (
        <div className="introducerFundingGap">
            <Sidebar />
            <MainView>
                <IntroducerFundingGapView />
            </MainView>
        </div>
    )
}

export default IntroducerFundingGap
